"use strict";
/**
 * Global Invoice (Factura Global) Enums and Constants
 *
 * Used for monthly consolidated invoices issued to RFC XAXX010101000
 * (Público en General) per Mexican SAT requirements.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_SAT_PRODUCT_CODE = exports.SAT_GLOBAL_PERIODICITY = exports.GLOBAL_INVOICE_RECEIVER = exports.CREDIT_NOTE_KIND_LABELS = exports.CreditNoteKind = exports.GLOBAL_INVOICE_STATUS_LABELS = exports.GlobalInvoiceStatus = void 0;
// ============================================================================
// Global Invoice Status
// ============================================================================
var GlobalInvoiceStatus;
(function (GlobalInvoiceStatus) {
    GlobalInvoiceStatus["draft"] = "draft";
    GlobalInvoiceStatus["stamping"] = "stamping";
    GlobalInvoiceStatus["stamped"] = "stamped";
    GlobalInvoiceStatus["failed"] = "failed";
    GlobalInvoiceStatus["cancelled"] = "cancelled";
})(GlobalInvoiceStatus || (exports.GlobalInvoiceStatus = GlobalInvoiceStatus = {}));
exports.GLOBAL_INVOICE_STATUS_LABELS = {
    [GlobalInvoiceStatus.draft]: "Borrador",
    [GlobalInvoiceStatus.stamping]: "Timbrando...",
    [GlobalInvoiceStatus.stamped]: "Timbrada",
    [GlobalInvoiceStatus.failed]: "Error",
    [GlobalInvoiceStatus.cancelled]: "Cancelada",
};
// ============================================================================
// Credit notes related to a global (GH581)
// ============================================================================
/** Why a credit note to público en general was issued against a global */
var CreditNoteKind;
(function (CreditNoteKind) {
    /** The month's card or transfer refunds of sales that went into a global */
    CreditNoteKind["month_returns"] = "month_returns";
    /** A ticket already in a stamped global, later invoiced to a customer */
    CreditNoteKind["customer_invoice"] = "customer_invoice";
})(CreditNoteKind || (exports.CreditNoteKind = CreditNoteKind = {}));
exports.CREDIT_NOTE_KIND_LABELS = {
    [CreditNoteKind.month_returns]: "Devoluciones del mes",
    [CreditNoteKind.customer_invoice]: "Facturado después a un cliente",
};
// ============================================================================
// Global Invoice Receiver (SAT standard)
// ============================================================================
/**
 * Fixed receiver data for global invoices (Público en General).
 * Per SAT CFDI 4.0 specifications.
 */
exports.GLOBAL_INVOICE_RECEIVER = {
    rfc: "XAXX010101000",
    name: "PUBLICO EN GENERAL",
    cfdiUse: "S01",
    fiscalRegime: "616",
};
// ============================================================================
// SAT Global Information - Periodicity (c_Periodicidad)
// ============================================================================
/**
 * SAT periodicity codes for the GlobalInformation node in global invoices.
 * @see SAT Catalog c_Periodicidad
 */
exports.SAT_GLOBAL_PERIODICITY = {
    daily: "01",
    weekly: "02",
    biweekly: "03",
    monthly: "04",
    bimonthly: "05",
};
/**
 * Fallback SAT product code when section mapping is not found.
 */
exports.DEFAULT_SAT_PRODUCT_CODE = "01010101";
